module.exports = __webpack_public_path__ + "static/media/cz.9e92e4ed.svg";